<div fxLayout="row" fxLayoutAlign="center" *ngIf="data.length !== 0">
  <mat-icon class="status-active"
            *ngIf="isAllSelected() else deselectedAll"
            (click)="deselectAll()">
    check_circle_outline
  </mat-icon>
  <ng-template #deselectedAll>
    <mat-icon  class="status-inactive"
               (click)="selectAll()">
      radio_button_unchecked
    </mat-icon>
  </ng-template>
</div>
